import DOMPurify from "dompurify";

/**
 * The last step before anything from the API is set as a card's innerHTML.
 *
 * A post reaches every visitor, and its text is written by whoever the feeds follow - on a repost, by
 * whoever they reposted. The only markup a card itself adds is the links linkifyContent makes and the
 * <mark> of the search highlight, so that is all that survives here: any other tag is dropped (its
 * text kept, except script and style), every attribute but href/target/rel goes, and so do
 * javascript: and other non-web URLs.
 *
 * Its own instance, so the link hook below changes no other use of DOMPurify.
 */
const purify = DOMPurify(window);

const CONFIG = {
    ALLOWED_TAGS: ["a", "mark", "br"],
    ALLOWED_ATTR: ["href", "target", "rel"],
};

// Every link in a card already opens a new tab. Enforced rather than trusted, so a link that arrived
// in the data cannot open without noopener and reach back into this page through window.opener.
purify.addHook("afterSanitizeAttributes", node => {
    if (node.tagName === "A") {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
    }
});

export function safeHtml(html: string): string {
    return purify.sanitize(html, CONFIG);
}
